import clsx from 'clsx';
import { FC } from 'react';
import { ProductDraftRequestPayload, Category } from '@interfaces/models/deposit';
import { useTranslation } from 'next-i18next';
import styles from './category-selector.module.scss';

type CategorySelectorProps = {
  handleChangeCategory: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  listingDraftPayload: ProductDraftRequestPayload;
  categories: Category[];
};

export const CategorySelector: FC<CategorySelectorProps> = ({
  listingDraftPayload,
  handleChangeCategory,
  categories,
}) => {
  const { t } = useTranslation('deposit-form');
  return (
    <div className={clsx('vc-formUnit', 'vc-formUnit--select', styles['depositForm__form--select'])}>
      <select
        id="preductAddCategory"
        data-cy="deposit-form-category-selector"
        name="page"
        className={clsx('vc-inputText', styles.depositForm__form__select, {
          [styles['depositForm__form__select--empty']]: !listingDraftPayload.category,
        })}
        data-error-required="Required field"
        onChange={handleChangeCategory}
        value={listingDraftPayload.category}
      >
        <option
          className={clsx(styles.depositForm__form__select__firstChoice)}
          value=""
        >
          {t('DEPOSIT_FORM.SELECT_CHOOSE')}
        </option>
        {categories &&
          categories.map((item) => (
            <optgroup
              label={item.title}
              key={item.id}
            >
              {item.subCategories.map((subItem) => (
                <option
                  value={subItem.id}
                  key={subItem.id}
                >
                  {subItem.title}
                </option>
              ))}
            </optgroup>
          ))}
      </select>
    </div>
  );
};
